<template>
  <div class="box">
    <v-server-table
      ref="datatable"
      :url="api"
      :name="tableName"
      :columns="columns"
      :options="options"/>
  </div>
</template>
<script>
const TableName = 'VUETABLE_HOURLY';
export default {
    data: function() {
        var that = this;
        return {
            tableName: TableName,
            columns: [
                'time',
                'total_pax',
                'sub_total',
                'discount',
                'taxes',
                'service_charge',
                'total_sales',
            ],
            options: {
                perPage: 24,
                perPageValues: [24],
                texts: {
                    title: 'Hourly Sales',
                    description: 'Shows hourly sale details',
                },
                useReportFilter: true,
                customFilters: ['outlet_id', 'since', 'until'],
                initFilters: {
                    outlet_id: that.$store.getters.activeOutlet,
                    since: that.$store.getters.startDate.format(),
                    until: that.$store.getters.endDate.format(),
                },
                columnsClasses: {
                    total_pax: 'text-right width-10',
                    sub_total: 'text-right width-10',
                    discount: 'text-right width-10',
                    taxes: 'text-right width-10',
                    service_charge: 'text-right width-10',
                    total_sales: 'text-right width-10',
                },
                headings: {
                    total_pax: 'Pax',
                    sub_total: `Sub Total`,
                    service_charge: `Service Charge`,
                    discount: `Discount`,
                    taxes: `Taxes`,
                    total_sales: `Grand Total`,
                },
                templates: {
                    total_pax: (h, row) => {
                        return numeral(parseFloat(row.total_pax)).format('0,0');
                    },
                    sub_total: (h, row) => {
                        return numeral(parseFloat(row.sub_total)).format();
                    },
                    discount: (h, row) => {
                        return numeral(parseFloat(row.discount)).format();
                    },
                    taxes: (h, row) => {
                        return numeral(parseFloat(row.taxes)).format();
                    },
                    service_charge: (h, row) => {
                        return numeral(parseFloat(row.service_charge)).format();
                    },
                    total_sales: (h, row) => {
                        return numeral(parseFloat(row.total_sales)).format();
                    },
                },
                pdf_url: Laroute.route('franchise.report.hourly.exportAsFile', {
                    type: 'PDF',
                }),
                csv_url: Laroute.route('franchise.report.hourly.exportAsFile', {
                    type: 'CSV',
                }),
                xls_url: Laroute.route('franchise.report.hourly.exportAsFile', {
                    type: 'XLSX',
                }),
            },
        };
    },

    computed: {
        api() {
            return Laroute.route('franchise.report.hourly.index');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/hourly/vuetable_hourly.vue